interface CardProps {
  colour?: string;
  children: React.ReactNode;
  className?: string;
  paddingX?: string;
  paddingY?: string;
  borderColour?: string;
  rounded?: string;
  borderWeight?: string;
  onClick?: () => void;
}

export default function Card({
  colour = "off-white",
  children,
  className = "",
  paddingX = "px-16",
  paddingY = "py-16",
  borderColour = "none",
  rounded = "6xl",
  borderWeight = "2",
  onClick = () => undefined
}: CardProps) {
  return (
    <div
      onClick={onClick}
      className={`bg-${colour} rounded-${rounded} ${paddingX} ${paddingY} border-${borderWeight} border-${borderColour} ${className}`}
    >
      {children}
    </div>
  );
}
